import React from 'react'
import Grid from '@mui/material/Grid'
import {flowRight as compose} from 'lodash'
import {withRouter} from 'react-router-dom'
import {withNamespaces} from 'react-i18next'
import PaymentsFilter from './PaymentsFilter'

const MobileFilterModal = (props) => {
  const {accounts, onChange, filter, accountId, rows, transactionsLimits} = props
  return (
    <Grid container direction="column">
      <PaymentsFilter
        accountId={accountId}
        accounts={accounts}
        filter={filter}
        onChange={filter => onChange(filter)}
        rows={rows}
        transactionsLimits={transactionsLimits}/>
    </Grid>
  )
}

export default compose(
  withNamespaces(),
  withRouter,
)(MobileFilterModal)
